/* eslint-disable jsx-a11y/anchor-has-content */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterUrl, isInternalLink} from "../../helpers/filters";

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphMobileComponentCallout {
          fieldTxtHeadline
          fieldLink {
            url {
              path
              routed
            }
            title
          }
        }
      }
    }
  }
}
`;

class MobileComponentCallout extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired,
    };

    static defaultProps = {
        componentIndex: null
    };

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;

                    markComponentLoadedAs(id, true);

                    return (
                        <section className="yitm__section yitm__callout">

                            <div className="container">
                                {field.fieldTxtHeadline ? (<h3>{field.fieldTxtHeadline}</h3>) : null}
                                {field.fieldLink && field.fieldLink.url && field.fieldLink.url.path ? (
                                    <a target={isInternalLink(field.fieldLink.url.path) ? '_self' : '_blank'}
                                       rel={isInternalLink(field.fieldLink.url.path) ? null : 'noopener noreferrer'}
                                       href={filterUrl(field.fieldLink.url.path)}>
                                        {field.fieldLink.title}
                                    </a>
                                ) : null}
                            </div>

                        </section>
                    );
                }}
            </Query>
        )
    }

}


export default MobileComponentCallout;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentCallout.jsx